import { ActionArea, ActionReference, CloseUpImage, GameObjectReference, GameState, ItemReference, MapRoomReference, SubImage } from "@shared/types";
import { LitElement, TemplateResult, css, html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { getState, navigate, performAction } from "../services/routeService";
import {ifDefined} from "lit/directives/if-defined.js";


@customElement("game-canvas")
export class GameCanvas extends LitElement {
    public static styles = css`
        .game {
            height: 100%;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: auto auto 1fr auto;
            grid-column-gap: 0px;
            grid-row-gap: 0px;
        }

        .title {
            width: 100%;
            display: flex;
            justify-content: center;
            margin: 0;
            margin-bottom: -32px;
            margin-top: 12px;
            z-index: 200;
        }

        .title p {
            margin: 0;
            padding: 8px 24px;
            color: #0f172a;
            background-color: #f1f5f9;
            border: 2px solid #94a3b8;
            border-radius: 100px;
        }

        .header {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            position: relative;
            margin-top: 10px;
            border: 2px solid #94a3b8;
            border-radius: 24px;
            overflow: hidden;
        }

        .header img {
            width: 100%;
            height: auto;
        }

        .header img:nth-child(n + 2) {
            position: absolute;
        }

        .content {
            display: flex;
            width: 100%;
            height: 100%;
            flex-direction: column;
            position: absolute;
            top: 0;
            left: 0;
            align-items: center;
        }

        .close-up-image-container {
            height: auto;
            max-width: 66%;
            width: auto;
            border: 8px #020617 solid;
            border-radius: 24px;
            margin: auto 0;
            z-index: 200;
            padding: 0;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
        }

        .close-up-image {
            /* width: calc(100% - 80px); */
            object-fit: cover;
            object-position: center;
            width: 100%;
            height: auto;
            margin: 0;
        }

        .content p {
            color: #0f172a;
            margin: 0;
        }

        .text-bubble {
            font-size: 0.85em;
            margin: 12px;
            margin-top: auto;
            background-color: #f8fafc;
            padding: 12px;
            border: 2px #94a3b8 solid;
            border-radius: 24px;
            width: calc(100% - 48px);
        }

        .footer {
            background-color: #f1f5f9;
            border: 2px solid rgb(148, 163, 184);
            border-radius: 24px;
            margin-top: 10px;
            display: flex;
            height: auto;
            margin-bottom: 10px;
        }

        .footer .buttons {
            display: flex;
            flex-direction: column;
            overflow: auto;
            padding: 12px;
        }

        .footer .button {
            background-color: #0f172a;
            border-radius: 8px;
            padding: 8px 12px;
            margin-right: 8px;
            margin-bottom: 4px;
            text-transform: uppercase;
            cursor: pointer;
            display: inline-block;
            user-select: none;
        }

        .footer > div:first-child > a {
            background-color: #0891b2;
        }

        .footer .button.active,
        .footer .button:hover {
            background-color: #0f172a;
        }

        .interact {
            position: absolute;
            z-index: 100;
        }
        
        .interact:hover {
            cursor: zoom-in;
        }

        .sub-image-button {
            position: absolute;
            z-index: 100;
        }

        .sub-image-button:hover {
            cursor: pointer;
        }

        .content-container {
            position: relative;
        }

        .image-close-button {
            background-color: #ef4444;
            padding: 8px;
            border-radius: 8px;
            height: 24px;
            z-index: 200;
        }

        .image-close-button:hover {
            cursor: pointer;
            background-color: #dc2626;
        }

        .image-close-button svg {
            width: 24px;
            height: 24px;
            color: #f8fafc;
        }
        
        .notifications-container {
            position: absolute;
            width: 100%;
            max-width: 300px;
            top: 0;
            right: 0;
            z-index: 1000;
        }

        .buttonMap {
            position: absolute;
            margin: 12px 0 8px 12px;
            text-transform: uppercase;
            cursor: pointer;
            display: inline-block;
            z-index: 220;            
        }

        #buttonInventory, #buttonClues,.inventoryOverlay, .cluesOverlay, #buttonEnding {
            color: white;
            font-family: Onesize;
            box-sizing: border-box;
            width: 150px;
            position: absolute;
            left: 12px;
            background-color: #020617;
            border-radius: 12px;
        }

        #buttonInventory,#buttonClues,#buttonEnding {
            font-size: 20px;
            top: 60px;
            padding: 10px 10px;
            cursor: pointer;
            z-index: 200;
            
        }

        #inventoryDiv {
            position: absolute;
        }
        #clueDiv{
            position: absolute;
            z-index:200;
            margin-top: 50px;
        }
        .cluesOverlay {
            top: 96px;
            list-style-type: none;
            padding: 8px;
            font-size: large;
            max-height: 300px;
            overflow-y: auto;
            background-color: #f1f5f9;
            border: 2px solid #94a3b8;
            border-radius: 8px;
            color: black;
        }
        .inventoryOverlay {
            top: 96px;
            list-style-type: none;
            padding: 8px;
            font-size: large;
            max-height: 300px;
            overflow-y: auto;
            background-color: #f1f5f9;
            border: 2px solid #94a3b8;
            border-radius: 8px;
            z-index:300;
        }

        .inventoryOverlay > li:not(:first-child) {
            margin-top: 10px;
        }
        .cluesOverlay > li:not(:first-child) { 
            margin-top: 10px;
        }
        .inventoryOverlay, .cluesOverlay > li {
            cursor: pointer;
            color: black;
            word-break: break-all;
        }

        #mapImg{
            height:500px;
            width:900px;
            margin-top:-10px;
            margin-left: 20px;
        }
        #toggleButtonMap {
            position: absolute;
            background-color: #020617;
            color:white;
            border-radius: 12px;
            cursor: pointer;
            display: inline-block;
            padding:10px;
            font-family: Onesize;
            font-size: 20px;
            width: 150px;
        }

        #toggleButtonMap.open  {
            background-color: #ef4444;
        }

        .map-container {
            position: absolute;
            width: 100%;
            height: calc(100% - 16px);
            background-color: #000000cf;
            z-index: 200;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 0px 0px 16px 0px;
        }

        .map-inner {
            height: 424px;
            width: 607px;
            /* aspect-ratio: 666/466; */
            background-image: url("/assets/img/rooms/map.png");
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            border-radius: 24px;
            position: relative;
        }

        #buttonMusic {
            z-index: 220; 
            background-color: #020617;
            color: white;
            border-radius: 12px;
            cursor: pointer;
            display: inline-block;
            padding: 2px;
            font-family: Onesize;
            font-size: 20px;
            width: 50px;
            position: absolute;
            top: 12px; /* Afstand vanaf de bovenkant van het scherm */
            right: 12px; /* Afstand vanaf de rechterkant van het scherm */
        }
        

        #endingDiv{
            position: absolute;
            z-index:200;
            margin-top: 100px;
        }
    `;
@property({ type: Boolean })
    private showMap = false;

@property({ type: Boolean })
    private showInventory = false;
@property({ type: Boolean })
    private showClues = false;
    private clues?: ItemReference[];
    private inventory?: ItemReference[];
    private roomTitle?: string;
    private roomImages?: string[];
    private roomAlias?: string;
    private contentText?: string[];
    private actionButtons?: ActionReference[];
    private gameObjectButtons?: GameObjectReference[];
    private closeUpImage?: CloseUpImage;
    private openImage?: string;
    private notification?: string;
    private selectedActionButton?: ActionReference;
    private mapRooms?: MapRoomReference[]; 
    private selectedGameObjectButtons: Set<GameObjectReference> = new Set<GameObjectReference>();
    private hideMapAndInventory?: boolean;
    private actionAreas?: ActionArea[];
    private showEndButton?: boolean;
    private gameMusic: HTMLAudioElement | undefined;
    public connectedCallback(): void {
        super.connectedCallback();

        void this.refreshState();
    }

    private async refreshState(): Promise<void> {
        const state: GameState = await getState();

        this.updateState(state);
    }

    private updateState(state: GameState): void {
        //Reset the component
        this.roomTitle = state.roomTitle;
        this.roomImages = state.roomImages;
        this.roomAlias = state.roomAlias;
        this.contentText = state.text;
        this.actionButtons = state.actions;
        this.gameObjectButtons = state.objects;
        this.closeUpImage = state.closeUpImage;
        this.openImage = this.closeUpImage?.id;
        this.notification = state.notification;
        this.selectedActionButton = undefined;
        this.mapRooms = state.mapRooms;
        this.selectedGameObjectButtons.clear();
        this.hideMapAndInventory = state.hideMapAndInventory;
        this.actionAreas = state.actionAreas;
        this.showEndButton = state.showEndButton;

        this.inventory = state.inventory;
        this.clues = state.clues;
        this.requestUpdate();
    }

    private async handleClickAction(button: ActionReference): Promise<void> {
        if (button.needsObject) {
            this.selectedActionButton = button;
            this.selectedGameObjectButtons.clear();

            this.requestUpdate();
        } else {
            const state: any = await performAction(button.alias);

            if (state === undefined) {
                return;
            }

            this.updateState(state);
        }
    }

    private async handleClickObject(button: GameObjectReference): Promise<void> {
        if (!this.selectedActionButton) {
            return;
        }

        this.selectedGameObjectButtons.add(button);

        const state: GameState | undefined = await performAction(
            this.selectedActionButton.alias,
            [...this.selectedGameObjectButtons].map((e) => e.alias)
        );

        if (this.selectedGameObjectButtons.size >= 2) {
            this.selectedActionButton = undefined;
            this.selectedGameObjectButtons.clear();
        }

        this.requestUpdate();

        if (state === undefined) {
            return;
        }

        this.updateState(state);
    }

    protected render(): TemplateResult {
        return html`
            <div class="game">
                ${this.renderTitle()} 
                <div class="content-container">
                    ${this.renderHeader()} 
                    ${this.renderContent()}
                    <div class="notifications-container">
                        ${
                            this.notification
                            ? html`<text-notification message="${this.notification}" stayTimeMillis="0"></text-notification>`
                            : nothing
                        }
                   </div>
                </div> 
                ${this.renderFooter()}
            </div>
        `;
    }

    private renderTitle(): TemplateResult {
        if (this.roomTitle) {
            return html`
            <div class="title">
                <p>${this.roomTitle}</p>
            </div>`;
        }

        return html`${nothing}`;
    }

    private async onInteract(event: Event): Promise<void> {
        const action: string = (event.target as HTMLElement).dataset.action!;
        const object: string | undefined = (event.target as HTMLElement).dataset.object;

        const state: GameState | undefined = await performAction(
            action,
            object ? [object] : []
        );
        
        if (state === undefined) {
            return;
        }

        this.updateState(state);
    }
    private async onMapClick(event: Event): Promise<void> {
        const id: string = (event.target as HTMLElement).id.replace("interact-", "");
        const state: GameState | undefined = await navigate(
            id,
        );
        if (state === undefined) {
            return;
        }
        this.showMap = false;
        this.updateState(state);
    }

    private toggleMap(): void {
        this.showMap = !this.showMap;
    }

    private toggleInventory(): void {
        this.showInventory = !this.showInventory;
    }
    private toggleClues(): void {
        this.showClues = !this.showClues;
    }
    
    private getClues(): TemplateResult {
        if (this.clues?.length === 0) {
            return html`<p class="cluesOverlay">No clues found yet</p>`;
        }
        else {
            return html`
            <ul class="cluesOverlay">
                    ${this.clues?.map((itemReference: ItemReference) => html`
                    <li @click="${(): Promise<void> => this.cluesCloseUp(itemReference.alias)}">${itemReference.name}</li>
                    `)}
                </ul>
            `;
        }
    }

    private getInventory(): TemplateResult {
        if (this.inventory?.length === 0) {
            return html`<p class="inventoryOverlay">Inventory is empty</p>`;
        }
        else {
            return html`
                <ul class="inventoryOverlay">
                    ${this.inventory?.map((itemReference: ItemReference) => html`
                    <li @click="${(): Promise<void> => this.inventoryCloseUp(itemReference.alias)}">${itemReference.name}</li>
                    `)}
                </ul>
            `;
        }
    }
    private async cluesCloseUp(itemAlias: string): Promise<void> {

        const state: GameState | undefined = await performAction(
            "examine",
            [itemAlias]
        );

        if (state === undefined) {
            return;
        }
        this.updateState(state);
    }

    private async inventoryCloseUp(itemAlias: string): Promise<void> {

        const state: GameState | undefined = await performAction(
            "examine",
            [itemAlias]
        );

        if (state === undefined) {
            return;
        }

        this.updateState(state);
    }

    private onCloseUpButtonPress(event: Event): void {
        const id: string = (event.target as HTMLElement).id.replace("sub-image-button-", "");
        this.openImage = id;
        this.requestUpdate();
    }

    private getCurrentSubImage(): SubImage {
        if(!this.openImage) {
            return {
                url: this.closeUpImage!.url
            };
        }

        if(this.closeUpImage?.id === this.openImage) {
            return {
                id: this.closeUpImage.id,
                url: this.closeUpImage.url,
                buttons: this.closeUpImage.buttons
            };
        }

        for(const subImage of this.closeUpImage!.subImages!) {
            if(subImage.id === this.openImage) {
                return subImage;
            }
        }

        return {
            url: ""
        };
    }

    private async onEndingClick(): Promise<void> {
        const state: GameState | undefined = await navigate(
            "end-screen",
        );
        if (state === undefined) {
            return;
        }
        this.updateState(state);
    }

    private async toggleMusic(): Promise<void> {
        const audioSrc: string = "/assets/img/rooms/song2.mp3";
    
        if (!this.gameMusic) {
            this.gameMusic = new Audio(audioSrc);
            this.gameMusic.addEventListener("ended", () => {
                if (this.gameMusic) {
                    this.gameMusic.currentTime = 0;
                    void this.gameMusic.play();
                }
            });
        }
    
        if (this.gameMusic?.paused) {
            try {
                await this.gameMusic.play();
                this.requestUpdate();
            } catch (error) {
                console.error("Muziek doet het niet", error);
            }
        } else {
            this.gameMusic?.pause();
            this.requestUpdate();
        }
    }

    private renderHeader(): TemplateResult {
        if (this.roomImages && this.roomImages.length > 0) {
            return html`
                <div class="header">
                    ${this.roomImages?.map((url) => html`<img src="/assets/img/rooms/${url}.png" />`)}
                    ${ this.hideMapAndInventory ? nothing : html`
                    <div class="buttonMap"> 
                        <button id="toggleButtonMap" @click="${this.toggleMap}" class="${this.showMap ? "open" : "" }">${this.showMap ? "Close Map" : "View Map"}</button>    
                    </div>
                    <div id="inventoryDiv">
                        <button id="buttonInventory" @click="${this.toggleInventory}">Inventory</button>
                        ${this.showInventory ? this.getInventory() : html``}
                    </div>
                    <div id="clueDiv">
                        <button id="buttonClues" @click="${this.toggleClues}">Clues</button>
                        ${this.showClues ? this.getClues() : html``}
                    </div>
                    ${this.showEndButton ? html`
                    <div id="endingDiv">
                        <button id="buttonEnding" @click="${this.onEndingClick}">Select suspect</button>
                    </div>
                    ` : nothing}

                    <div class="musicDiv">
                        <button  id="buttonMusic" @click="${this.toggleMusic}">${this.gameMusic === undefined ? html`🔇` : html`${this.gameMusic.paused ? html`🔇` : html`🔊`}`}</button>
                    </div>
                    `}
    
                    ${
                        this.actionAreas?.map((value) => 
                            html`
                                <div class="interact" data-action="${value.action}" data-object="${ifDefined(value.object)}" style="width: ${value.interactionBox.width}px; height: ${value.interactionBox.height}px; transform: translate3D(${value.interactionBox.offsetX}px, ${value.interactionBox.offsetY}px, 0);" @click="${this.onInteract}"></div>
                            `
                        )
                    }
                    
                    ${
                        this.showMap ? html`
                            <div class="map-container">
                                <p>Click on the map to navigate to another room</p>
                                <div class="map-inner">
                                    <!-- <img id="mapImg" src="/assets/img/rooms/map.png"/> -->
                                </div>
                                ${ this.mapRooms?.map((value) => html`
                                    <div class="interact" id="interact-${value.alias}" style="width: ${value.clickArea.width}px; height: ${value.clickArea.height}px; transform: translate3D(${value.clickArea.offsetX}px, ${value.clickArea.offsetY}px, 0);" @click="${this.onMapClick}"></div>
                                `) }
                            </div>
                        ` : nothing
                    }
                </div>
            `;
        }
        return html`${nothing}`;
    }

    private async closeCloseUp(): Promise<void> {
        this.closeUpImage = undefined;

        const state: GameState | undefined = await performAction(
            "examine",
            [this.roomAlias!]
        );

        if (state === undefined) {
            return;
        }

        this.updateState(state);
    }

    private renderContent(): TemplateResult {
        return html`
            <div class="content">
                ${
                    this.closeUpImage
                    ? html`
                        <div class="close-up-image-container">
                            <img class="close-up-image" src="/assets/img/rooms/${this.getCurrentSubImage().url}.png" />
                            ${
                                this.getCurrentSubImage().buttons?.map((button) => html`<div class="sub-image-button" id="sub-image-button-${button.imageId}" style="width: ${button.interactionBox.width}px; height: ${button.interactionBox.height}px; transform: translate3D(${button.interactionBox.offsetX}px, ${button.interactionBox.offsetY}px, 0);" @click="${this.onCloseUpButtonPress}"></div>`)
                            }
                        </div>
                        <div class="image-close-button" @click="${this.closeCloseUp}">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                            </svg>
                        </div>
                    `
                    : nothing
                }

                ${this.contentText?.map((text) => html`<div class="text-bubble"><p>${text}</p></div>`)}
            </div>
        `;
    }

    private renderFooter(): TemplateResult {
        return html`
            <div class="footer">
                <div class="buttons">
                    <div>
                        ${this.actionButtons?.map(
                            (button) => html`<a
                                class="button ${this.selectedActionButton === button ? "active" : ""}"
                                @click=${(): void => void this.handleClickAction(button)}
                                >${button.label}</a
                            >`
                        )}
                    </div>
                    <div>
                        ${this.selectedActionButton
                            ? this.gameObjectButtons?.map(
                                  (button) => html`<a
                                      class="button ${this.selectedGameObjectButtons.has(button)
                                          ? "active"
                                          : ""}"
                                      @click=${(): void => void this.handleClickObject(button)}
                                      >${button.name}</a
                                  >`
                              )
                            : nothing}
                    </div>
                </div>
            </div>
        `;
    }
}
